






















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import BasicInput from '../Inputs/basicInput.vue';
import BasicMaskedInput from '../Inputs/basicMaskedInput.vue';
import Icon from '../Icon.vue';


  @Component({
    name: 'deliveryDownloadAccessForm',
    components: {
      BasicInput,
      BasicMaskedInput,
      Icon,
    },
  })
export default class deliveryDownloadAccessForm extends Vue {
    /**
     * Annotation Validation Providers for TS
     */
    $refs!: {
      emailValidator: InstanceType<typeof ValidationProvider>;
      confirmedEmailValidator: InstanceType<typeof ValidationProvider>,
      contactPersonPhoneValidator: InstanceType<typeof ValidationProvider>,
      disableCopy
      disablePaste
    };

    @Prop({ type: Boolean, default: false }) isCard!: Boolean;

    private storeContactPerson = this.$store.state.contactPerson;

    get personAnswer() {
      return this.storeContactPerson.answer;
    }

    set personAnswer(newUserAnswer) {
      this.$store.dispatch('contactPerson/handelUserAnswerChange', newUserAnswer);
    }

    get personEmail() {
      return this.storeContactPerson.email;
    }

    set personEmail(newEmail) {
      this.$store.dispatch('contactPerson/handleEmailChange', newEmail);
    }

    get personEmailConfirmation() {
      return this.storeContactPerson.otherEmail;
    }

    set personEmailConfirmation(newConfirmedEmail) {
      this.$store.dispatch('contactPerson/handleOtherEmailChange', newConfirmedEmail);
    }

    get phoneNumber() {
      return this.storeContactPerson.phoneNumber;
    }

    set phoneNumber(newPhoneNumber) {
      this.$store.dispatch('contactPerson/handlePhoneNumberChange', newPhoneNumber);
    }

    // eslint-disable-next-line class-methods-use-this
    public disableDefaultEvent(event) {
      event.preventDefault();
      return false;
    }

    private clearFormData() {
      this.personEmail = '';
      this.personEmailConfirmation = '';
      this.phoneNumber = '';
      this.clearValidatorStatus();
    }

    private clearValidatorStatus() {
      this.$refs.emailValidator.reset();
      this.$refs.confirmedEmailValidator.reset();
      this.$refs.contactPersonPhoneValidator.reset();
    }
}
